import { SVGICON } from "../../constant/theme";
import {
    ALL_USER_PERM,
    ONLY_ADMIN_PERM,
    ONLY_CISF_PERM,
    ONLY_VISITOR_PERM,
    ONLY_SUPER_ADMIN_PERM,
    EXCEPT_VISITOR_PERM_PERM,
    EXCEPT_VISITOR_CISF_PERM_PERM
} from "../../permission";
export const MenuList = [

    {
        title: 'Dashboard',
        iconStyle: SVGICON.MenuDashboard,
        to: '/dashboard',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'Documents',
        iconStyle: SVGICON.MenuReport,
        to: '/document',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'TE-Sheets',
        iconStyle: SVGICON.MenuSheet,
        to: '/te-sheet',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'Audit',
        iconStyle: SVGICON.MenuAudit,
        to: '/audit',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'Calibration',
        iconStyle: SVGICON.MenuCalibration,
        to: '/calibration',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'Users',
        iconStyle: SVGICON.MenuUsers,
        to: '/user',
        accessRole: ["SuperAdmin"]
    },
    {
        title: 'Quiz',
        iconStyle: SVGICON.MenuQuiz,
        to: '/quiz',
        accessRole: ALL_USER_PERM
    },
    {
        title: 'Division',
        iconStyle: SVGICON.MenuDivision,
        to: '/division',
        accessRole: ["SuperAdmin"]
    },

]
